import {Fragment} from "preact";
import s from "./fullPageLoader.module.css";
import {iconLoader} from "../../../assets";
import {useAppContext} from "../../../contexts";

const FullPageLoader = () => {
    // Destructures the state that will control the loader display state
    const {fullPageLoader} = useAppContext();

    return fullPageLoader ? (
        <Fragment>
            <div className={`fixed inset-0 w-screen h-screen z-50 ${s.root}`}>
                <div className="relative h-full w-full z-0">
                    <img
                        src={iconLoader}
                        className={`${s.loader} dark:grayscale`}
                        alt={"Loader icon"}
                    />
                    <div className={s.backdrop} />
                </div>
            </div>
        </Fragment>
    ) : null;
}

export default FullPageLoader;
